import script from "./Quote.vue?vue&type=script&setup=true&lang=js"
export * from "./Quote.vue?vue&type=script&setup=true&lang=js"

import "./Quote.vue?vue&type=style&index=0&id=58083189&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58083189"]])

export default __exports__